import React, { useState, useEffect } from 'react';

const AnalysisTypeChoice = ({ 
  imageUrl, 
  onSelectAnalysisType, 
  onCancel,
  isMultiple = false,
  imageCount = 1,
  images = [], // Array of image objects for multiple images
  userPrompt = '',
  onPromptChange = () => {}
}) => {
  const [localPrompt, setLocalPrompt] = useState(userPrompt);
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl border p-6 max-w-lg w-full shadow-lg">
        {/* Image Preview */}
        {isMultiple && images.length > 0 ? (
          <div className="mb-6">
            <p className="text-sm text-muted-foreground mb-2">
              {images.length} image{images.length > 1 ? 's' : ''} ready
            </p>
            <div className="grid grid-cols-4 gap-2">
              {images.slice(0, 4).map((image, index) => (
                <div key={index} className="relative rounded-md overflow-hidden border bg-muted aspect-square">
                  <img 
                    src={image.signedUrl || image.url || image} 
                    alt={`${index + 1}`} 
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      const fallbackDiv = document.createElement('div');
                      fallbackDiv.className = 'absolute inset-0 flex items-center justify-center text-muted-foreground text-lg';
                      fallbackDiv.textContent = '📷';
                      e.target.parentNode.appendChild(fallbackDiv);
                    }}
                  />
                  <div className="absolute top-1 right-1 bg-background/90 backdrop-blur-sm rounded-full w-5 h-5 flex items-center justify-center text-[13px] font-medium">
                    {index + 1}
                  </div>
                </div>
              ))}
              {images.length > 4 && (
                <div className="rounded-md border bg-muted aspect-square flex items-center justify-center">
                  <span className="text-xs text-muted-foreground font-medium">+{images.length - 4}</span>
                </div>
              )}
            </div>
          </div>
        ) : imageUrl ? (
          <div className="mb-6">
            <div className="relative rounded-md overflow-hidden border bg-muted">
              <img 
                src={imageUrl} 
                alt="Preview" 
                className="w-full h-40 object-cover"
              />
            </div>
          </div>
        ) : null}

        {/* Header */}
        <div className="mb-6">
          <h3 className="text-lg font-medium leading-none mb-1.5">
            What should I analyze in {isMultiple ? 'these photos' : 'this photo'}?
          </h3>
          <p className="text-muted-foreground text-sm">
            Choose the type of analysis for your photo{isMultiple ? 's' : ''}.
          </p>
        </div>

        {/* Analysis Options - PRODUCT ANALYSIS REMOVED (moved to Product Catalog) */}
        <div className="space-y-2 mb-6">
          <button
            onClick={() => onSelectAnalysisType('skin')}
            className="w-full p-3 bg-[#FFE4D6] border border-[#FFD4BF] rounded-md hover:bg-[#FFD9C7] transition-colors text-left flex items-center gap-3"
          >
            <div className="w-9 h-9 rounded-md bg-white/60 flex items-center justify-center text-xl">
              👤
            </div>
            <div className="flex-1">
              <div className="font-medium text-sm text-[#2A324B]">Skin Analysis</div>
              <div className="text-xs text-[#2A324B]/70">tone, texture, undertone, concerns</div>
            </div>
          </button>

          {/* REMOVED: Product Analysis - Now available in Product Catalog */}
          {/* <button
            onClick={() => onSelectAnalysisType('product')}
            className="w-full p-3 bg-[#FFE4D6] border border-[#FFD4BF] rounded-md hover:bg-[#FFD9C7] transition-colors text-left flex items-center gap-3"
          >
            <div className="w-9 h-9 rounded-md bg-white/60 flex items-center justify-center text-xl">
              🧴
            </div>
            <div className="flex-1">
              <div className="font-medium text-sm text-[#2A324B]">Product</div>
              <div className="text-xs text-[#2A324B]/70">identify brand & shade</div>
            </div>
          </button> */}
          
          <div className="text-center p-3 bg-muted/30 rounded-md">
            <p className="text-xs text-muted-foreground">
              💡 <span className="font-medium">For product analysis:</span> Use Product Catalog → Analyze Now
            </p>
          </div>
        </div>

        {/* Optional Prompt */}
        <div className="mb-6">
          <label className="block text-sm font-medium mb-2">
            Specific question (optional)
          </label>
          <textarea
            value={localPrompt}
            onChange={(e) => {
              setLocalPrompt(e.target.value);
              onPromptChange(e.target.value);
            }}
            placeholder="e.g., 'Does this work for my skin?', 'Can I use these together?'"
            className="flex w-full rounded-md border border-input bg-background px-3 py-2 text-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50 focus-visible:border-ring disabled:cursor-not-allowed disabled:opacity-50 resize-none transition-[color,box-shadow]"
            rows={2}
          />
        </div>

        {/* Tip */}
        <div className="bg-muted/50 border rounded-md p-3 mb-6">
          <div className="flex items-start gap-2">
            <span className="text-sm">💡</span>
            <p className="text-xs text-muted-foreground leading-relaxed">
              <span className="font-medium text-foreground">Tip:</span> Upload clear face photos for best skin analysis results
            </p>
          </div>
        </div>

        {/* Cancel Button */}
        <button
          onClick={onCancel}
          className="inline-flex items-center justify-center w-full h-9 px-4 rounded-md border border-input bg-background hover:bg-accent hover:text-accent-foreground transition-colors text-sm font-medium"
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default AnalysisTypeChoice;
